const testUpload = {
    title: 'テストデータアップロード',
    description: '開発・テスト用のドキュメントを一括アップロードします。',
    incidentDirectory: 'インシデントファイルディレクトリ: /upload_data/incident file/',
    quickUpload: 'クイックアップロード',
    selectIncidentFiles: 'インシデントファイルを選択してアップロード',
    quickUploadHelp: '過去トラファイルを選択すると自動的にメタデータが設定されます。',
    detailedUpload: '詳細設定アップロード',
    category: 'カテゴリー',
    categories: {
      incident: '過去トラ',
      finance: '財務',
      planning: '企画',
      analytics: '分析',
      engineering: 'エンジニアリング',
    },
    selectFiles: 'ファイルを選択',
    selectedFiles: '選択されたファイル: {{count}}件',
    startUpload: 'アップロード開始',
    uploading: 'アップロード中...',
    results: 'アップロード結果',
    successCount: '成功: {{count}}件',
    failureCount: '失敗: {{count}}件',
    succeededFiles: '成功したファイル:',
    failedFiles: '失敗したファイル:',
    instructionsTitle: '使用方法:',
    instructions: {
      quick: '「インシデントファイルを選択してアップロード」をクリックして過去トラファイルを一括アップロード',
      detailed: 'または「詳細設定アップロード」でカテゴリーを選択してファイルをアップロード',
      metadata: 'ファイル名から自動的にメタデータが生成されます（インシデントファイルの場合）',
      review: 'アップロード完了後、ドキュメント一覧ページで確認できます',
    },
  };

export default testUpload;
